// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"MH-z","smallCardRow":"NH-z","largeCardRow":"OH-z","productSearchRow":"PH-z","curatedRow":"QH-z"};